module.exports = __webpack_public_path__ + "static/media/BTT.46b88739.png";